export default "__VITE_ASSET__CrcLijSI__"